import { useState, useEffect, useCallback } from 'react';
import { Outlet } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
import { Box, Typography, Container } from '@mui/material';
// config
import { BOTTOM_NAV } from '../../config';
// hooks
import useTelegram from '../../hooks/useTelegram';
// utils
import axios from '../../utils/axios';
//
import BottomNav from './BottomNav';
import LoadingScreen from '../../components/LoadingScreen';
import PhoneRegistration from '../../components/PhoneRegistration';

// ----------------------------------------------------------------------

const MainStyle = styled('main')({
  flexGrow: 1,
  paddingBottom: BOTTOM_NAV.HEIGHT + 16,
});

// ----------------------------------------------------------------------

export default function DashboardLayout() {
  const { telegramUser, isReady } = useTelegram();
  const [authState, setAuthState] = useState({ loading: true, hasPhone: false });

  const checkAuth = useCallback(async () => {
    if (!telegramUser) return;
    try {
      const { data } = await axios.get('/students/auth/check');
      setAuthState({ loading: false, hasPhone: data.registered && data.hasPhone });
    } catch {
      setAuthState({ loading: false, hasPhone: false });
    }
  }, [telegramUser]);

  useEffect(() => {
    if (isReady && telegramUser) {
      checkAuth();
    } else if (isReady) {
      setAuthState({ loading: false, hasPhone: false });
    }
  }, [isReady, telegramUser, checkAuth]);

  if (!isReady || authState.loading) {
    return <LoadingScreen />;
  }

  if (!telegramUser) {
    return (
      <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center' }}>
        <Container maxWidth="xs" sx={{ textAlign: 'center' }}>
          <Typography variant="h5" gutterBottom>EssePro</Typography>
          <Typography color="text.secondary">
            Iltimos, ilovani Telegram orqali oching.
          </Typography>
        </Container>
      </Box>
    );
  }

  if (!authState.hasPhone) {
    return <PhoneRegistration onSuccess={checkAuth} />;
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <MainStyle>
        <Outlet />
      </MainStyle>

      <BottomNav />
    </Box>
  );
}
